export default function LotteryRules({ show, onClose }) {
    if (!show) return null;

    return (
        <>
            <style>
                {`
                    h1{
                        font-size: 40px;
                        font-weight: 800;
                    }
                    h3 {
                        font-size: 28px;
                    }
                    p{
                        font-size: 15px;
                        font-weight: 500;
                    }    
                    .modal-header {
                        background-color: #fff;
                        color: #000;
                        padding: 1rem;
                        display: flex;
                        align-items: center;
                        max-width: 100% !important;
                        width: 100%
                    }
                    .modal-content {
                        max-width: 800px;
                        max-height: calc(100vh - 40px);
                        margin-top: 25px;
                        background-color: #fff;
                        color: #000;
                        border-radius: 8px;
                        margin-left: auto; 
                        margin-right: auto; 
                        width: 100% !important;
 
                    }
                    .imgt20 {
                        max-width: 100%;  
                        height: auto;     
                        display: block;
                    }
                    #market-rules-text ol {
                        list-style-type: decimal;
                        padding-left: 40px;
                    }
                    #market-rules-text ol li {
                        list-style: list-item !important;
                    }
                    .modal-overlay {
                        position: fixed; 
                        top: 0;
                        left: 0;
                        width: 100vw;
                        height: 100vh;
                        background: rgba(0, 0, 0, 0.5);
                        display: flex;
                        justify-content: center;
                        align-items: flex-start;
                        z-index: 9999;
                        overflow-y: auto;
                        }
                `}
            </style>
            {show && (
                <div className="modal-overlay">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Market Rules</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" onClick={onClose}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div id="market-rules-text" class="modal-body">
                            <div>
                                <div>
                                    <center>
                                        <h1><b>Lottery</b></h1>
                                        <h2>Rules and Regulations</h2>
                                        <hr></hr>
                                        <div>
                                            <h3><b>GAME OBJECTIVES</b></h3>
                                            <p class="pt20">To guess whether the 1/2/3 cards selected will be drawn by the Dealer (in that order) or not.</p>
                                        </div>

                                        <div>
                                            <h3><b>GAME RULES</b></h3>
                                            <p class="pt20"><b>Hands dealt: 1 (3 cards).</b></p>
                                            <p class="pt20"><b>Single: If the First hand dealt is same as the selected card.</b></p>
                                            <p class="pt20">Double: If the First &amp; Second hands dealt are same as the selected cards.</p>
                                            <p class="pt20">Triple: If the First, Second &amp; Third hands dealt are same as the selected cards.</p>
                                            <p class="pt20">Cards used: All suits (Spade, Diamond, Clubs, Hearts) of A to 10.</p>
                                            <p class="pt20">Note: Ace is considered as value "1"; 10 is "0".</p>
                                            <p class="pt20">Ex: 2 Hearts, 10Diamonds, A Clubs = 201</p>
                                        </div>

                                        <h3><b>Payout </b></h3>
                                        <div>
                                            <div>
                                                <div>
                                                    <p class="pt20">Hand rankings 3-Card. </p>
                                                    <p class="pt20">(From Highest to lowest)</p>
                                                    <table class="table table-bordered table-sm">
                                                        <tbody>
                                                            <tr>
                                                                <th>single</th>
                                                                <th>1 to 8</th>
                                                            </tr>
                                                            <tr>
                                                                <th>Double</th>
                                                                <th>1 to 79</th>
                                                            </tr>
                                                            <tr>
                                                                <th>Triple</th>
                                                                <th>1 to 699</th>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </center>
                                </div>
                            </div>


                        </div>
                    </div>



                </div>
            )}
        </>
    );
}